export default __webpack_public_path__ + "static/media/family-gathering-mobile@2x.2fc17bad.jpg";